import client from './client';

export function getInbox() {
  return client.get('/api/change-requests/inbox');
}

export function getInboxCount() {
  return client.get('/api/change-requests/inbox-count');
}

export function approve(requestId, requestRevision) {
  return client.post(`/api/change-requests/${requestId}/approve`, { requestRevision });
}

export function reject(requestId, reason, requestRevision) {
  return client.post(`/api/change-requests/${requestId}/reject`, { reason, requestRevision });
}
